import { Component, OnInit } from '@angular/core';
import { CalamityStepModel } from '../models/calamity-step.model';
import { Location } from "@angular/common";
import {
  faArrowLeft,
  faPlaneDeparture,
  faUsers,
  faUserInjured,
  faClipboardCheck,
  faList,
  faFolderOpen,
  faCheckSquare,
  faHospital,
  faHospitalUser,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Subject } from 'rxjs';
import { CalamityService } from '../calamity.service';
import { takeUntil } from 'rxjs/operators';
import { CedNotificationService } from 'ced-ng-library';

@Component({
  selector: 'app-calamity-wizard',
  templateUrl: './calamity-wizard.component.html',
  styleUrls: ['./calamity-wizard.component.scss']
})
export class CalamityWizardComponent implements OnInit {
  private subject$ = new Subject();
  calamityId : string;
  steps: CalamityStepModel[] = [
    {
      step: 0,
      label: "Basic Details",
      isActive: true,
      enabled: true,
      url: "/calamity/calamityWizard/calamityBasicDetails",
      icon: "faClipboardCheck",
    },
    {
      step: 0,
      label: "Actions",
      isActive: false,
      enabled: false,
      url: "/calamity/calamityWizard/calamityActionsList",
      icon: "faClipboardCheck",
    },
    {
      step: 0,
      label: "Notes",
      isActive: false,
      enabled: false,
      url: "/calamity/calamityWizard/calamityNotesList",
      icon: "faClipboardCheck",
    },
    {
      step: 0,
      label: "Dossier",
      isActive: false,
      enabled: false,
      url: "/calamity/calamityWizard/calamityDossierList",
      icon: "faFolderOpen",
    }
  ];
  arrowBack = faArrowLeft;
  faClipboardCheck = faClipboardCheck;
  UserInjured = faUserInjured;
  faHospital = faHospital;
  faHospitalUser = faHospitalUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faPlaneDeparture = faPlaneDeparture;
  faUsers = faUsers;
  faList = faList;
  faFolderOpen = faFolderOpen;
  faCheckSquare = faCheckSquare;
  constructor(private _location: Location,
    private cedNotificationService: CedNotificationService,
    private calamityService: CalamityService) { }

  ngOnInit() {
    this.getCalamityId();
  }

  getCalamityId(){
    this.calamityService.calId$.pipe(takeUntil(this.subject$))
    .subscribe(res=> {
       this.calamityId=res;
       if (this.calamityId!=null && this.calamityId!=undefined ){
        this.steps.forEach(element => {
             element.isActive=true;
             element.enabled=true;
           });
       }
    },
    (error) => {
        this.cedNotificationService.error("NOTIFICATIONS.GET_CALAMITY_BY_ID");
    }
    );
  }

  isBackDisplayed(): boolean {
    let _lastUrl = window.location.href.split('/').pop();
    let _lastStep = this.steps.find(step => step.url == _lastUrl);
    if (_lastStep) {
      return this.steps.some(s => s.step < _lastStep.step && s.isActive && s.enabled);
    }
    return false;
  }

  backClicked(): void {
    this._location.back();
  }

  trackByFn(index, item): void {
    return index.step;
  }

  geticon(name: string): void {
    return this[name];
  }

  ngOnDestroy(): void {
    this.subject$.unsubscribe();
  }

}
